module.exports = __webpack_public_path__ + "img/google-maps-marker.660db459.png";